// Public branding is only for signed-out pages. A failed authenticated
// request must never fall back to another company's editable settings.
export function createTenantLoader(api) {
  let generation = 0;
  return {
    invalidate() { generation += 1; },
    async load(user, isCurrent, receive, fail) {
      const request = ++generation;
      const current = () => request === generation && isCurrent();
      try {
        const { data } = await api.get(user ? "/tenant" : "/tenant/public");
        if (user && data.id !== user.tenant_id) {
          throw new Error("The returned company does not match this account.");
        }
        if (current()) receive(data);
      } catch (error) {
        if (current()) fail(error);
      }
    },
  };
}
